import {fetchWithState, getFetchedJSON} from '~/misc/fetch';

export const getDetailByLatLng = (getState, position) => {
  return fetchWithState(getState, {
    url: `/v1/search/location/latlng/v2?latitude=${position.lat}&longitude=${position.lng}`,
    method: 'GET',
    header: {
      'api-key': '6ZQcE55ax2Zp(wDdLaq74aPDuXzSVWun'
    },
  }, false).then(getFetchedJSON)
}



// WEBPACK FOOTER //
// ./src/api/getDetailByLatLng.js